import $api from "@http";

export default class ProductsService {
  static async getCountries() {
    return $api.get(`/api/v1/countries`);
  }

  static async getProductLine() {
    return $api.get(`/api/v1/product_lines`);
  }

  static async getProducts({page, size, search, sort, with_archived}) {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("page_size", size);
    params.append("with_archived", with_archived);

    if (search) {
      const dateRegex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-(\d{4})$/;

      if (dateRegex.test(search.trim())) {
        params.append("q[created_at_gteq]", search.trim());
      } else {
        params.append("q[search_cont]", search);
      }
    }

    if (sort?.value === "product_line") {
      params.append("q[s][]", `product_line_name ${sort.direction || "asc"}`);
    } else if (sort?.value === "status") {
      params.append(
        "q[s][]",
        `product_version_state ${sort.direction || "asc"}`,
      );
    } else if (sort?.value) {
      params.append(
        "q[s][]",
        `${sort.value.toLowerCase()} ${sort.direction || "asc"}`,
      );
    }

    return $api.get(`/api/v1/products?${params.toString()}`);
  }

  static async getAllProducts() {
    return $api.get(`/api/v1/products/bootcamp_allowed`);
  }

  static async viewProduct({id}) {
    return $api.get(`/api/v1/products/${id}`);
  }

  static async createProduct({product}) {
    const hasCoverFile =
      product.product.cover &&
      (product.product.cover instanceof File ||
        (product.product.cover.file &&
          product.product.cover.file instanceof File) ||
        (product.product.cover.path && product.product.cover.path !== ""));

    const hasDocumentFiles = product.product_version?.files?.some(
      (file) => file.file && file.file instanceof File,
    );

    if (hasCoverFile || hasDocumentFiles) {
      const formData = new FormData();

      Object.keys(product.product).forEach((key) => {
        if (
          product.product[key] !== null &&
          product.product[key] !== undefined
        ) {
          if (key === "cover" && product.product.cover) {
            if (product.product.cover instanceof File) {
              formData.append("product[cover]", product.product.cover);
            } else if (
              product.product.cover.file &&
              product.product.cover.file instanceof File
            ) {
              formData.append("product[cover]", product.product.cover.file);
            } else if (product.product.cover.path) {
              formData.append(
                "product[cover]",
                JSON.stringify(product.product.cover),
              );
            }
          } else {
            formData.append(`product[${key}]`, product.product[key]);
          }
        }
      });

      if (product.product_version) {
        Object.keys(product.product_version).forEach((key) => {
          if (key === "files" && product.product_version.files) {
            product.product_version.files.forEach((file) => {
              formData.append(`product_version[files][][level]`, file.level);
              if (file.file && file.file instanceof File) {
                formData.append(`product_version[files][][file]`, file.file);
              }
            });
          } else if (
            product.product_version[key] !== null &&
            product.product_version[key] !== undefined
          ) {
            formData.append(
              `product_version[${key}]`,
              product.product_version[key],
            );
          }
        });
      }

      return $api.post(`/api/v1/products`, formData);
    } else {
      const cleanProduct = {
        ...product,
        product: {
          ...product.product,
          cover: product.product.cover || undefined,
        },
      };
      return $api.post(`/api/v1/products`, cleanProduct);
    }
  }

  static async updateProduct({id, product}) {
    const hasFiles =
      product.product.cover &&
      (product.product.cover instanceof File ||
        (product.product.cover.file &&
          product.product.cover.file instanceof File) ||
        (product.product.cover.path && product.product.cover.path !== ""));

    if (hasFiles) {
      const formData = new FormData();

      Object.keys(product.product).forEach((key) => {
        if (
          product.product[key] !== null &&
          product.product[key] !== undefined
        ) {
          if (key === "cover" && product.product.cover) {
            if (product.product.cover instanceof File) {
              formData.append("product[cover]", product.product.cover);
            } else if (
              product.product.cover.file &&
              product.product.cover.file instanceof File
            ) {
              formData.append("product[cover]", product.product.cover.file);
            } else if (product.product.cover.path) {
              formData.append(
                "product[cover]",
                JSON.stringify(product.product.cover),
              );
            }
          } else {
            formData.append(`product[${key}]`, product.product[key]);
          }
        }
      });

      if (product.product_version) {
        Object.keys(product.product_version).forEach((key) => {
          if (
            product.product_version[key] !== null &&
            product.product_version[key] !== undefined
          ) {
            formData.append(
              `product_version[${key}]`,
              product.product_version[key],
            );
          }
        });
      }

      return $api.patch(`/api/v1/products/${id}`, formData);
    } else {
      return $api.patch(`/api/v1/products/${id}`, product);
    }
  }

  static async getScenarios() {
    return $api.get(`/api/v1/scenarios/simulations_allowed`);
  }

  static async archiveProduct({id}) {
    return $api.post(`/api/v1/products/${id}/archive`);
  }

  static async unArchiveProduct({id}) {
    return $api.post(`/api/v1/products/${id}/restore`);
  }

  static async deleteProduct({id, without}) {
    const params = new URLSearchParams();

    if (without) params.append("with_scenarios", without);

    return $api.delete(`/api/v1/products/${id}?${params.toString()}`);
  }

  static async getAttachedScenarios({id}) {
    return $api.get(`/api/v1/products/${id}/scenarios`);
  }
}
